import React, { useEffect, useRef, useState } from 'react';
import "./animations.css"

const FadeInElement = ({ children }) => {
    const elementRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const options = {
        threshold: 0.5,
      };
  
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      }, options);
  
      observer.observe(elementRef.current);
  
      // Cleanup the observer when the component is unmounted
      return () => observer.disconnect();
    }, []);
  
    return (
      <div
        ref={elementRef}
        className={`fade-in-element ${isVisible ? 'in-view' : ''}`}
      >
        {children}
      </div>
    );
  };
  


const ZoomInElement = ({ children }) => {
  const elementRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const options = {
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      });
    }, options);

    observer.observe(elementRef.current);

    // Cleanup the observer when the component is unmounted
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={elementRef}
      className={`zoom-in-element ${isVisible ? 'in-view' : ''}`}
    >
      {children}
    </div>
  );
};
const MoveRightElement = ({ children }) => {
    const elementRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const options = {
        threshold: 0.5,
      };
  
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      }, options);
  
      observer.observe(elementRef.current);
  
      // Cleanup the observer when the component is unmounted
      return () => observer.disconnect();
    }, []);
  
    return (
      <div
        ref={elementRef}
        className={`move-right-element ${isVisible ? 'in-view' : ''}`}
      >
        {children}
      </div>
    );
  };
  const MoveLeftElement = ({ children }) => {
    const elementRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const options = {
        threshold: 0.5,
      };
  
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      }, options);
  
      observer.observe(elementRef.current);
  
      // Cleanup the observer when the component is unmounted
      return () => observer.disconnect();
    }, []);
  
    return (
      <div
        ref={elementRef}
        className={`move-left-element ${isVisible ? 'in-view' : ''}`}
      >
        {children}
      </div>
    );
  };
  const TypingEffect = ({ text = '' }) => {
  
  
    return <span className="typeWriter"> {text}</span>;
  };

  // birtday anim

  const BalloonContainer = ({ numBalloons = 10, birthdayPerson, show = false }) => {
    const [balloons, setBalloons] = useState([]);
  
    const random = (num) => Math.floor(Math.random() * num);
  
    const getRandomStyles = () => {
      const r = random(255);
      const g = random(255);
      const b = random(255);
      const mt = random(200);
      const ml = random(50);
      const dur = random(5) + 5;
      const animationName = 'float';
      const animationTimingFunction = 'ease-in';
      const animationIterationCount = 'infinite';
      const animationDelay = `${random(numBalloons * 0.5)}s`; // Random delay for each balloon
    
      return {
        backgroundColor: `rgba(${r},${g},${b},0.7)`,
        color: `rgba(${r},${g},${b},0.7)`,
        boxShadow: `inset -7px -3px 10px rgba(${r - 10},${g - 10},${b - 10},0.7)`,
        margin: `${mt}px 0 0 ${ml}px`,
        animation: `${animationName} ${dur}s ${animationTimingFunction} ${animationIterationCount}`,
        animationDelay: animationDelay,
      };
    }
  
    const createBalloons = (num) => {
      const newBalloons = Array.from({ length: num }, (_, index) => index + 1);
      setBalloons(newBalloons);
    };
  
    const removeBalloons = () => {
      setBalloons([]);
    };
  
    useEffect(() => {
      createBalloons(numBalloons);
      const timeoutId = setTimeout(() => {
        removeBalloons();
      }, 9000);
  
      // Cleanup the timeout to prevent memory leaks
      return () => clearTimeout(timeoutId);
    }, [numBalloons]);
  
    return (
      show && false &&(
        <div id="balloon-container">
          {balloons.map((_, index) => (
            <div
              key={index}
              className="balloon"
              style={getRandomStyles()}
            >
              <div className="string"></div>
              <div className="triangle">▲</div>
              <div className="birthday-wish">
                Today is {birthdayPerson}'s birthday! 🎉
              </div>
            </div>
          ))}
        </div>
      )
    );
  };
  
  export default BalloonContainer;



export {FadeInElement,ZoomInElement,MoveLeftElement,MoveRightElement,TypingEffect,BalloonContainer};
